"use client";

import React from "react";
import Action from "./Action";
import { X as XIcon } from "@churchofjesuschrist/eden-icons";
import useValueOnMount from "./use-value-on-mount";
import buildURL from "./build-url";
import { jsx as _jsx } from "react/jsx-runtime";
const useXShareUrl = ({
  shareHashTags = "",
  shareText,
  shareUrl,
  shareVia
} = {}) => buildURL("https://x.com/intent/tweet", {
  search: {
    hashtags: shareHashTags,
    text: useValueOnMount(() => shareText || document.title),
    url: useValueOnMount(() => shareUrl || window.location.href),
    via: shareVia
  }
});

/**
 * A button that triggers a share to X, to be used within an `ActionBar`.
 * @param {object} props - The component props
 * @param {string} [props.label] - Hidden text label for the button.
 * @param {string} [props.shareUrl] - The URL to share. Defaults to `window.location.href` once mounted.
 * @param {string} [props.shareText] - The additional text to share. Defaults to `document.title` once mounted.
 * @param {string} [props.shareVia] - The post attribution.
 * @param {string} [props.shareHashTags] - A comma-separated string of hash tags without the "#"s (e.g. "blessed,cats").
 * @returns {React.ReactElement} The X component
 */
const X = ({
  shareHashTags = "",
  shareText,
  shareUrl,
  shareVia,
  label = "X",
  ...props
}) => /*#__PURE__*/_jsx(Action, {
  ...props,
  href: useXShareUrl({
    shareHashTags,
    shareText,
    shareUrl,
    shareVia
  }),
  Icon: XIcon,
  label: label
});
X.displayName = "X";
export default X;